<template>
    <div class="animated fadeIn container-fluid">
        <div v-if="edit_user">
            <div class="proj-toolbox-area">
                <b-row>
                    <b-col md="6">

                            <h4 v-text="$t('menu.user') + ' ' + $t('menu.management')"></h4>

                            <div v-if="edit_user" class="edit-area">

                                <h4 class="card-title agri-color">
                                    <b-img rounded="circle" class="user-pic"
                                            :src="get_UserPic(edit_user.pic)" :alt="edit_user.first_name + ' ' + edit_user.last_name"
                                    ></b-img>
                                    <div class="user-name">{{ edit_user.first_name }} {{ edit_user.last_name }}</div>
                                </h4>
                                <div class="device">
                                    <div class="block-text">User ID：{{ edit_user.id }}</div>
                                    <!-- <b-badge :variant="$tools.style.variantStatusButton('user', edit_user.status, false)">{{ $t('status.user.' + edit_user.status ) }}</b-badge> -->

                                    <div>
                                        <i class="fa fa-envelope block-text"></i>{{ edit_user.email }}
                                    </div>

                                    <div>
                                        <i class="fa fa-desktop block-text"></i>Language：{{ edit_user.language }}
                                    </div>

                                    <div>
                                        <i class="fa fa-calendar block-text"></i>Update Time：{{ edit_user.updated_at }}
                                    </div>
                                    <div>
                                        <i class="fa fa-calendar block-text"></i>Create Time：{{ edit_user.created_at }}
                                    </div>

                                </div>

                                <hr>

                            </div>

                    </b-col>
                    <b-col md="6">

                        <div class="edit-area">

                            <div class="area-overflow-x grab-bing scroll-style" v-dragscroll>
                                <div class="block-sm">{{ $t('menu.user') }} 身分</div>
                                <div class="block-sm">
                                    <b-form-radio-group v-model="edit_user.is_admin" :plain="true" buttons>
                                        <b-form-radio :value="true" button-variant="outline-danger" >管理員 Admin</b-form-radio>
                                        <b-form-radio :value="false" button-variant="outline-success" >一般使用者 General User</b-form-radio>
                                    </b-form-radio-group>
                                </div>
                            </div>

                            <div class="area-overflow-x grab-bing scroll-style" v-dragscroll>
                                <div class="block-sm">{{ $t('menu.user') }} {{ $t('menu.status') }}</div>
                                <div class="block-sm">
                                    <b-form-radio-group v-model="edit_user.status" :plain="true" buttons>
                                        <b-form-radio v-for="(status, idx_status) in admin_UserStatus_List" :key="idx_status"
                                                    :value="status.value" :button-variant="status.buttonVariant" >{{ $t('status.user.' + status.value) }}</b-form-radio>
                                    </b-form-radio-group>
                                </div>
                            </div>

                            <div>
                                <b-input-group class="mb-3">
                                    <b-input-group-prepend>
                                        <b-input-group-text><i class="icon-menu"></i>{{ $t('menu.admin_note') }}</b-input-group-text>
                                    </b-input-group-prepend>
                                    <b-form-textarea type="text" v-model="edit_user.note" :rows="1" :max-rows="6"></b-form-textarea>
                                </b-input-group>
                            </div>

                            <div class="text-center">
                                <b-button variant="success" class="px-4 btn-upload" @click="upload_userInfo(edit_user)" :disabled="uploading" >
                                    {{ $t('menu.save_changes') }}
                                </b-button>
                            </div>

                        </div>
                    </b-col>

                    <b-col md=12 v-if="user_admin">
                        <h4>重設使用者密碼</h4>
                        <b-button variant="danger" class="px-4 btn-upload" @click="reset_Password()">{{ $t('menu.reset_password') }}</b-button>
                        <div class="d-inline ml-2" v-if="randomPassword">
                            已重設密碼：{{ randomPassword }}
                            <BtnCopyToClipboard :copy_content="randomPassword" :btn_text="''" :tooltip_text="'copy password'"
                                                btn_style="small" :btn_variant="'outline-warning'">
                            </BtnCopyToClipboard>
                        </div>
                    </b-col>
                </b-row>
            </div>

            <div class="proj-toolbox-area">
                <h4 v-text="$t('menu.user') + ' 專案關聯'"></h4>

                <b-row>
                    <b-col md=6 v-for="(relation, idx_r) in user_relations" :key="idx_r">
                        <b-alert show variant="success">
                            {{ relation.name }} (ID={{ relation.id }})
                            <i class="fa fa-external-link-square block-text clickable" @click="goToPage('project', { projectID: relation.id }, true)"></i>

                            <b-badge variant="warning" class="block-text"><i :class="$tools.style.classRoleIcon(relation.role)"></i>{{ $t('n.' + relation.role) }}</b-badge>
                            <div v-if="relation.note">
                                ( {{ $t('menu.admin_note') }}：{{ relation.note }} )
                            </div>

                        </b-alert>
                    </b-col>
                </b-row>

            </div>

        </div>
        <div v-else class="proj-toolbox-area">
            <h4>無此使用者，請確認是否為正確的 User ID 或 User Email：{{ $route.params.userID }}</h4>
        </div>

        <div>
            <UserLogs v-if="edit_user" :userID="edit_user.id"></UserLogs>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import { dragscroll } from 'vue-dragscroll'  // 滑鼠可拖拉 scroll 區域
import UserLogs from '@/views/admin/common/Logs_User'
import BtnCopyToClipboard from '@/views/components/Button_CopyToClipboard'

export default {
    directives: {
        'dragscroll': dragscroll,
    },
    components: {
      UserLogs,
      BtnCopyToClipboard,
    },
    data() {
        return {
            uploading: false,
            timezone: 'Asia/Taipei',
            edit_userID: undefined,
            edit_user: undefined,
            user_relations: [],
            randomPassword: '',
        }
    },
    computed: {
        ...mapState({
            'user_admin': state => state.user.is_admin,
            'user_email': state => state.user.email,
            'user_first_name': state => state.user.first_name,
            'user_last_name': state => state.user.last_name,
            'admin_User_List': state => state.user.users,
            'admin_UserStatus_List': state => state.user.list_status,
        }),
    },
    mounted ()
    {
        this.edit_userID = this.$route.params.userID;
        this.timezone = this.$tools.date.getTimezoneNow();
        this.getUser_byID();
    },
    methods:
    {
        write_OPLog (action, querySettings = {})
        {
            // 送出使用者操作紀錄 --------------------
            let _OPLog = {
                user_id: this.$store.state.user.id,
                type: 'write',
                detail: {
                    page: 'user',
                    action: action,
                    querySettings: {
                        'user ID':              this.edit_userID,
                        'user email':           this.edit_user.email,
                        'user name':            this.edit_user.last_name + ' ' + this.edit_user.first_name,
                    },
                    pageInfo: {
                        'executor email':       this.user_email,
                        'executor name':        this.user_last_name + ' ' + this.user_first_name,
                    },
                },
            }

            for (let setting in querySettings)
            {
                _OPLog.detail.querySettings[ setting ] = querySettings[ setting ]
            }
            this.$store.dispatch('user/createLog', _OPLog).then( res => {}).catch( err => {})
            // 送出使用者操作紀錄 --------------------
        },

        reset_Password ()
        {
            let _new_password = this.get_RandomPassword()
            this.randomPassword = undefined;
            this.uploading = true;

            let _data = {
                passwd: _new_password,
            };

            const options = {
                method:'PUT',
                url: this.$config.getAPI_URL('Admin_Reset_Password', { userID: this.edit_userID }),
                data: _data
            }
            this.$http(options)
                .then( res => {

                    this.uploading = false;
                    this.randomPassword = _new_password;
                    this.write_OPLog('admin resetpassword', { 'password': _new_password });
                    this.$toastr.s( this.$t('other.update_succeeded'), this.$t('menu.user') + this.$t('menu.reset_password') );
                })
                .catch( err => {

                    this.uploading = false;
                    this.$toastr.e( this.$t('other.update_failed') + '<br>' + err.data.status + '<br>' + err.data.message,
                                    this.$t('menu.user') + this.$t('menu.reset_password') );
                })


        },

        get_RandomPassword ()
        {
            // 確認隨機碼裡含有數字
            let _randon_code = this.$tools.input.randomCode()
            while ( this.$tools.num.checkHasNumber( _randon_code ) == false )
            {
                _randon_code = this.$tools.input.randomCode()
            }

            return 'agriFriend@' + _randon_code
        },

        get_UserPic (userPic)
        {
            if (userPic != undefined) return userPic
            return this.$store.state.user.default_avatar
        },

        goToPage: function (type, params = {}, openNewTab = false)
        {
            let routeData = this.$config.getPagesURL( type, params )

            if (routeData != undefined)
            {
                if (openNewTab) {
                    let _url = this.$router.resolve( routeData )
                    window.open( _url.href, '_blank' );
                }
                else { this.$router.push( routeData ); }
            }
        },

        // 上傳並更新使用者資訊
        upload_userInfo (user)
        {
            this.uploading = true;

            let _data = {
                is_admin:  user.is_admin,
                status:    user.status,
                note:      user.note,
            };

            const options = {
                method:'PUT',
                url: this.$config.getAPI_URL('Edit_User', { userID: user.id }),
                data: _data
            }
            this.$http(options)
            .then( res => {

                this.uploading = false;
                this.write_OPLog('admin update', _data);
                this.getUser_byID();
                this.$toastr.s( this.$t('other.update_succeeded'), this.$t('menu.user') + ': ID=' + user.id + ' ' + user.email );
            })
            .catch( err => {

                this.uploading = false;
                this.$toastr.e( this.$t('other.update_failed') + '<br>' + err.data.status + '<br>' + err.data.message,
                                this.$t('menu.user') + ': ID=' + user.id + ' ' + user.email );
            })

        },

        getUser_byID ()
        {
            const settings = {
                timezone: this.timezone,
            }
            this.$store.dispatch('user/getUsers', settings)
                .then( res => {

                    this.admin_User_List.forEach( _user => {

                        if ( _user.id == this.edit_userID || _user.email == this.edit_userID )
                        {
                            this.edit_user = this.$tools.data.deepCopy_object( _user );
                            this.getUser_Relations()
                        }
                    })

                })
                .catch( err => {
                })
        },

        getUser_Relations ()
        {
            this.user_relations = []

            const options = {
                method:'GET',
                url: this.$config.getAPI_URL('Get_User_Relations', { userID: this.edit_user.id }),
            }
            this.$http(options)
                .then( res => {

                    if ( res.data.projects ) this.user_relations = res.data.projects
                })
                .catch( err => {

                })
        },
    }
}
</script>

<style lang="scss" scoped>

.user-pic
{
    display: inline-block;
    vertical-align: middle;
    width: 50px;
    height: 50px;
    margin-right: 15px;
}
.user-name
{
    display: inline-block;
    vertical-align: middle;
    font-size: 1.6rem;
}

.edit-area
{
    padding: 10px 15px;
}

</style>
